<template>
  <div class="banner">
    <div
      id="pcBanner"
      class="carousel slide carousel-vertical banner-carousel"
      data-ride="carousel"
    >
      <ol class="carousel-indicators">
        <li
          v-for="(bannerUrl, i) in pcBannerList"
          :key="i"
          data-target="#pcBanner"
          :data-slide-to="i"
          :class="{ active: i === 0 }"
        ></li>
      </ol>
      <div class="carousel-inner h-100">
        <div
          v-for="(bannerUrl, i) in pcBannerList"
          :key="i"
          :class="{ 'carousel-item': true, active: i === 0 }"
        >
          <img class="lazyload d-block w-100" :data-src="bannerUrl" />
        </div>
      </div>
    </div>

    <div id="mobileBanner" class="carousel slide banner-carousel-m" data-ride="carousel">
      <ol class="carousel-indicators">
        <li
          v-for="(bannerUrl, i) in mobileBannerList"
          :key="i"
          data-target="#mobileBanner"
          :data-slide-to="i"
          :class="{ active: i === 0 }"
        ></li>
      </ol>
      <div class="carousel-inner h-100">
        <div
          v-for="(bannerUrl, i) in mobileBannerList"
          :key="i"
          :class="{ 'carousel-item': true, active: i === 0 }"
        >
          <img class="lazyload d-block w-100" :data-src="bannerUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lazyload from 'lazyload'
export default {
  name: 'Banner',
  props: {
    pcBannerList: Array,
    mobileBannerList: Array,
  },
  setup() {},
  mounted() {
    const images = document.querySelectorAll('img.lazyload')
    new lazyload(images)
  },
}
</script>

<style scoped>
.carousel-next-btn,
.carousel-preview-btn {
  background-image: url('/images/mobile/carousel-next-dark.png');
}

.carousel-next-btn.dark,
.carousel-preview-btn.dark {
  background-image: url('/images/mobile/carousel-prev-dark.png');
}

.carousel-next-btn.dark {
  transform: rotate(180deg);
}

.carousel-preview-btn.dark {
  transform: rotate(0);
}

.scroll-prev:hover .carousel-preview-btn.dark,
.scroll-prev:focus .carousel-preview-btn.dark {
  transform: rotate(180deg);
}

.scroll-next:hover .carousel-next-btn.dark,
.scroll-next:focus .carousel-next-btn.dark {
  transform: rotate(0);
}

.scroll-prev:hover .carousel-preview-btn,
.scroll-prev:focus .carousel-preview-btn,
.scroll-next:hover .carousel-next-btn,
.scroll-next:focus .carousel-next-btn {
  background-image: url('/images/mobile/carousel-next-light.png');
}
</style>
